




















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import InternalNotes from '@/components/common/inputs/InternalNotes.vue';
import { NewComment, ProcessReport } from '@/store/modules/processInterfaces';
import { Type, TypeKeys } from '@/models/types';

import Comments from '@/components/details/Comments.vue';
import IntervalSelector from '@/components/common/inputs/IntervalSelector.vue';
import FormSection from '@/components/details/FormSection.vue';
import ProcessHeader from '@/components/details/process/ProcessHeader.vue';
import UmbrellaForm from '@/components/details/umbrella/UmbrellaForm.vue';
import GeneralInformationForm from '@/components/details/general-information/GeneralInformationForm.vue';
import Button from '@/components/common/inputs/Button.vue';
import ChallengesForm from '@/components/details/challenges/ChallengesForm.vue';
import AssessmentForm from '@/components/details/assessment/AssessmentForm.vue';
import ImplementationForm from '@/components/details/implementation/ImplementationForm.vue';
import TimeAndProcessForm from '@/components/details/time-process/TimeAndProcessForm.vue';
import AttachmentsForm from '@/components/details/attachments/AttachmentsForm.vue';
import OperationForm from '@/components/details/operation/OperationForm.vue';
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue';
import EditIcon from '@/components/icons/EditIcon.vue';
import { umbrellaLabels, umbrellaKeys } from '@/store/modules/errorInterfaces';
import { ErrorState, ErrorModule } from '@/store/modules/error';
import SnackBar from '@/components/common/SnackBar.vue';
import { isEmpty } from 'lodash';
import { VisibilityKeys } from '@/models/visibility';
import { SearchFilters } from '@/store/modules/searchInterfaces';
import { SearchModule } from '@/store/modules/search';
import { ProcessModule } from '@/store/modules/process';
import { AuthModule } from '@/store/modules/auth';
import { isIE } from '@/services/url-service';
import { OrganisationModule } from '@/store/modules/organisation';

@Component({
  components: {
    FormSection,
    ProcessHeader,
    UmbrellaForm,
    GeneralInformationForm,
    Comments,
    IntervalSelector,
    ChallengesForm,
    AssessmentForm,
    TimeAndProcessForm,
    AttachmentsForm,
    ImplementationForm,
    OperationForm,
    Button,
    ArrowLeftIcon,
    EditIcon,
    SnackBar,
    InternalNotes
  }
})
export default class Umbrella extends Vue {
  @Prop(Boolean)
  isReporting!: boolean;
  @Prop(Number)
  id!: number;
  @Prop(String)
  type!: Type;

  showSaveSuccess = false;
  showSaveError = false;

  clearErrors() {
    ErrorModule.clearErrors();
  }

  get errors() {
    return ErrorModule;
  }

  hashLink(target: string) {
    return `#${target}`;
  }

  clickedHashLink() {
    this.$emit('clickedHashLink');
  }

  goBack() {
    if (isIE()) {
      this.$emit('goBack');
    }
    this.$router.push('/search');
  }

  beforeCreate() {
    ErrorModule.clearErrors();
  }

  mounted() {
    OrganisationModule.loadMunicipalityDetails(AuthModule.user?.cvr? AuthModule.user.cvr : null);

    if (this.isReporting) {
      ProcessModule.update({
        type: this.type,
        canEdit: true,
        hasChanged: false,
        cvr: AuthModule.user?.cvr,
        visibility: this.type === TypeKeys.PARENT ? VisibilityKeys.MUNICIPALITY : VisibilityKeys.PUBLIC,
        disabled: {
          rapidEdit: false,
          generalInformationEdit: false,
          challengesEdit: false,
          timeAndProcessEdit: false,
          assessmentEdit: false,
          operationEdit: false,
          implementationEdit: false,
          attachmentsEdit: false,
          internalNotesEdit: false
        }
      });
    }

    SearchModule.resetFilters();

    const filters: Partial<SearchFilters> = {
      umbrella: false,
      visibility: {
        MUNICIPALITY: this.type === TypeKeys.PARENT,
        PUBLIC: false
      }
    };

    SearchModule.updateFilters(filters);
  }

  async save() {
    try {
      const success = await ProcessModule.save(umbrellaKeys);
      this.showSaveSuccess = success;
    } catch (e) {
      this.showSaveError = true;
    }
  }

  async report() {
    try {
      const processId = await ProcessModule.createReport(umbrellaKeys);
      if (!processId) {
        // if we don't get a process id back, a validation error occurred.
        return;
      }
      this.showSaveSuccess = true;
      this.$router.push(`/details/${processId}`);
    } catch (e) {
      this.showSaveError = true;
    }
  }
}
